import { render, staticRenderFns } from "./DebaterCertificate.vue?vue&type=template&id=52f03960&scoped=true&"
import script from "./DebaterCertificate.vue?vue&type=script&lang=js&"
export * from "./DebaterCertificate.vue?vue&type=script&lang=js&"
import style0 from "./DebaterCertificate.vue?vue&type=style&index=0&id=52f03960&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f03960",
  null
  
)

export default component.exports